const chooseMissingFirstArgument = /\{\\choose\d+\}/u;
const chooseMissingSecondArgument = /\{\d+\\choose\}/u;
const chooseOrphanedBraces = /\{\}/u;

export const combinatoricsDeleteScenarios = [
    // Deleted first argument (n) of `n choose r`, insert placeholder to replace
    {
        isScenarioPresent: value => chooseMissingFirstArgument.test(value),
        handleScenario: editor => editor.executeCommand(['insert', '\\placeholder{}']),
    },
    // Deleted second argument (r) of `n choose r`, insert placeholder to replace
    {
        isScenarioPresent: value => chooseMissingSecondArgument.test(value),
        handleScenario: editor => editor.executeCommand(['insert', '\\placeholder{}']),
    },
    // Deleted `choose` operator entirely, leaving an orphaned set of braces. Delete the braces.
    {
        isScenarioPresent: value => chooseOrphanedBraces.test(value),
        handleScenario: editor => {
            editor.executeCommand('moveToNextChar');
            editor.executeCommand('deleteBackward');
        },
    },
];

/**
 * Return the filtered keybindings for the Combinatorics virtual keyboard.
 * @param {Array} keybindings The original keybindings to filter.
 * @returns {Array} The filtered keybindings.
 */
export function filterCombinatoricsKeybindings(keybindings) {
    const commandsToKeep = [
        'moveToPreviousChar',
        'moveToNextChar',
        'moveToMathfieldStart',
        'moveToMathfieldEnd',
        'deleteBackward',
        'deleteForward',
        'selectAll',
        'cutToClipboard',
        'copyToClipboard',
        'pasteFromClipboard',
        'undo',
        'redo',
    ];
    const keysToKeep = ['/'];

    return keybindings.filter(({ command, key }) => commandsToKeep.includes(command) || keysToKeep.includes(key));
}

/**
 * The Combinatorics virtual keyboard layout.
 * @param {Object} commonKeys The common keys used across different virtual keyboard layouts.
 * @returns {Array} The keyboard layout.
 */
export function getCombinatoricsKeyboardLayout(commonKeys) {
    const { deleteKeyCap, exponent, fraction, moveLeftKeyCap, moveRightKeyCap, nextStepKeyCap, separator } = commonKeys;
    const rows = [];

    rows.push(
        ['1', '2', '3', '+', '-', exponent, '!'],
        [
            '4',
            '5',
            '6',
            '\\cdot',
            fraction,
            { class: 'small', insert: 'P(#@, \\placeholder{})', latex: 'P(n, r)' },
            { class: 'small', insert: '{#@ \\choose \\placeholder{}}', latex: '{n \\choose r}' },
        ],
        ['7', '8', '9', separator, separator, '(', ')'],
        [moveLeftKeyCap, '0', moveRightKeyCap, deleteKeyCap, separator, separator, nextStepKeyCap],
    );

    return rows;
}
